import dayjs from "@/lib/helpers/dayjs";

// Known date string formats used across the API
const KNOWN_FORMATS = [
  "YYYY-MM-DD HH:mm",
  "YYYY-MM-DD HH:mm:ssZ",
  "MM/DD/YYYY HH:mm",
  "MM/DD/YYYY HH:mm:ss",
];

// Returns null for invalid dates so callers can skip rather than corrupt sort order
export function toUnixTimestamp(dateStr: string): number | null {
  // API stores some dates as unix seconds (10-digit numeric string)
  if (/^\d{10}(\.\d+)?$/.test(dateStr)) {
    const unix = parseFloat(dateStr);

    return isFinite(unix) ? unix : null;
  }

  const parsed = dayjs(dateStr, KNOWN_FORMATS, true);

  return parsed.isValid() ? parsed.unix() : null;
}
